import "./enlacesInformativos.css";

const RecursosAnfitrion = () => {
  return (
    <div className="informacion mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px] lg:px-0 px-[20px]">
      <h1 className="text-3xl font-bold mb-4">Recursos de Anfitrión</h1>
      <section>
        <h3>Introducción</h3>
        <p>
          Bienvenido al Centro de Recursos para Anfitriones. Aquí encontrarás
          todo lo que necesitas para gestionar tu alojamiento con éxito.
        </p>

        <h3>Crear y Optimizar tu Anuncio</h3>
        <ul>
          <li>
            <strong>Título claro y atractivo:</strong> Resalta las mejores
            características.
          </li>
          <li>
            <strong>Fotos de alta calidad:</strong> Asegúrate de que sean
            nítidas y representen fielmente el espacio.
          </li>
          <li>
            <strong>Descripción detallada:</strong> Explica las comodidades y
            servicios cercanos.
          </li>
          <li>
            <strong>Precio competitivo:</strong> Investiga precios similares en
            tu área.
          </li>
        </ul>

        <h3>Gestión de Reservas</h3>
        <ul>
          <li>
            <strong>Confirmación inmediata:</strong> Revisa y confirma las
            reservas lo antes posible.
          </li>
          <li>
            <strong>Bloqueo de fechas:</strong> Actualiza tu disponibilidad
            según necesidad.
          </li>
          <li>
            <strong>Comunicaciones con los huéspedes:</strong> Mantén un tono
            amable y profesional.
          </li>
        </ul>

        <h3>Políticas y Reglas del Alojamiento</h3>
        <ul>
          <li>
            <strong>Check-in/check-out:</strong> Establece horarios claros.
          </li>
          <li>
            <strong>Política de cancelación:</strong> Define si es flexible o
            estricta.
          </li>
          <li>
            <strong>Normas de la casa:</strong> Especifica reglas clave como no
            fumar o no fiestas.
          </li>
        </ul>

        <h3>Gestión de Reputación y Reseñas</h3>
        <ul>
          <li>
            <strong>Proporciona una excelente experiencia:</strong> Mantén el
            alojamiento limpio y cómodo.
          </li>
          <li>
            <strong>Solicita retroalimentación:</strong> Pide a los huéspedes
            que dejen una reseña.
          </li>
          <li>
            <strong>Responde siempre con cortesía:</strong> Agradece los
            comentarios positivos y negativos.
          </li>
        </ul>

        <h3>Precios y Promociones</h3>
        <ul>
          <li>
            <strong>Investiga precios de la competencia:</strong> Ajusta según
            la temporada.
          </li>
          <li>
            <strong>Ofertas por temporada baja:</strong> Atrae huéspedes con
            descuentos especiales.
          </li>
        </ul>

        <h3>Atención al Huésped</h3>
        <ul>
          <li>
            <strong>Responde rápidamente:</strong> Contesta mensajes y consultas
            de manera eficiente.
          </li>
          <li>
            <strong>Sé proactivo:</strong> Proporciona información útil antes de
            la llegada.
          </li>
          <li>
            <strong>Resuelve problemas eficientemente:</strong> Atiende
            cualquier inconveniente lo antes posible.
          </li>
        </ul>

        <h3>Herramientas y Recursos</h3>
        <ul>
          <li>
            <a href="/guia-optimizar-anuncio">Guía para optimizar tu anuncio</a>
          </li>
          <li>
            <a href="/soporte-tecnico">Soporte técnico</a>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default RecursosAnfitrion;
